@if(isSuccess){
    <order-wizard-payment-success></order-wizard-payment-success>
}
@else {
    <order-wizard-payment-failure></order-wizard-payment-failure>
}